<template>
  <div class="d-inline-flex w-100 py-2 px-4 bg-white rounded">
    <b-navbar toggleable="sm" type="dark" variant="white" class="d-none">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-button class="btn btn-sm btn-secondary text-exitos d-none">
            <font-awesome-icon icon="plus" />
            Nova Oportunidade
          </b-button>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form class="d-none">
            <b-form-input size="sm" class="mr-sm-2" placeholder="Pesquisar" />
            <b-button size="sm" class="my-2 my-sm-0" type="submit">
              Busca rápida
            </b-button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
      <User />
    </b-navbar>
    <badge-commit class="align-self-center ml-auto" />
  </div>
</template>
<script>
import BadgeCommit from "@/components/BadgeCommit.vue";
import User from "@/components/SidebarPlugin/User.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { User, BadgeCommit },
});
</script>
